import React from 'react';
import PropTypes from 'prop-types';

import { Title as DefaultTitle } from '../../containers/DefaultStyles/Shared';

const Title = props => (
    <DefaultTitle
        isLongText={props.isLongText}
        isExtraLongText={props.isExtraLongText}
        onClick={e => props.onPartnerClick(true, e)}
        dangerouslySetInnerHTML={{
            __html: props.shortActionName
        }}
    />
);

Title.propTypes = {
    isLongText: PropTypes.bool.isRequired,
    isExtraLongText: PropTypes.bool.isRequired,
    shortActionName: PropTypes.string,
    onPartnerClick: PropTypes.func
};

export default Title;
